import React, { Component } from "react";
import servicesData from "./servicedata";

class Services extends Component {
  handleServiceClick = (service) => {
    const slug = service.title.toLowerCase().replace(/\s+/g, "-");
    this.props.navigate(`/service/${slug}`);
  };

  render() {
    return (
      <div>
        <section
          id="services"
          className="colorlib-about"
          data-section="services"
        >
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-4 col-md-offset-4 col-md-pull-4 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">What I do?</span>
                <br />
                <h2 className="colorlib-heading">My Expertise</h2>
              </div>
            </div>
            <div className="row row-pt-md">
              {servicesData.map((service, index) => (
                <div
                  key={index}
                  className="col-md-4 col-sm-6 text-center animate-box"
                >
                  <div
                    className="services color-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.handleServiceClick(service)}
                  >
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/services-thumb/" +
                          (index + 1) +
                          ".png"
                        }
                        alt="Service"
                      />
                    </span>
                    <div className="desc">
                      <h3>{service.title}</h3>
                      <p style={{ fontSize: "12px" }}>{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Services;
